var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1869 17.3536C10.9916 17.5488 10.675 17.5488 10.4798 17.3536L6.47978 13.3536C6.28452 13.1583 6.28452 12.8417 6.47978 12.6464L10.4798 8.64645C10.675 8.45118 10.9916 8.45118 11.1869 8.64645C11.3821 8.84171 11.3821 9.15829 11.1869 9.35355L8.04044 12.5L17.5 12.5C17.7761 12.5 18 12.7239 18 13C18 13.2761 17.7761 13.5 17.5 13.5L8.04044 13.5L11.1869 16.6464C11.3821 16.8417 11.3821 17.1583 11.1869 17.3536Z",
    fill: "#4F4F4F",
    stroke: "#4F4F4F",
    strokeWidth: 0.333333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back_icon.3dc9bd6bf5aa0324eaa7587a5b9d1351.svg";
export { ForwardRef as ReactComponent };